import type Controller from '@ember/controller';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class RoutinesIndexRoute extends Route {
	@service('ai-chat') declare aiChatService: Service.AIChat;

	override setupController(controller: Controller, model: unknown): void {
		super.setupController(controller, model);

		// The list has no open routine → clear the id, mirroring genie/chat/index.ts. Defence in depth rather than
		// a live fix: navigation-main already reports no routine here, because routeConfig resolves routines.index
		// to AI_ROUTINES. This keeps urlRoutineId honest to its name for any future reader — the parent `routines`
		// route stays mounted across index/detail/run, so its resetController never runs between them.
		this.aiChatService.applyUrlRoutine(null);
	}
}
